import { Spinner } from "@material-tailwind/react";
import CardTable from "../Table/CustomTable"
import { useTranslation } from "react-i18next"
import { useState, useEffect } from "react";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import * as Papa from 'papaparse';
import { BASE_NAME } from "../../routes";
import { bibtexToIEEE } from "../../utils";

const Papers = () => {

    const translationPrefix = 'Papers'
    const { t } = useTranslation('global');
    const [publicaciones, setPublicaciones] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const columns = [
        {
            id: 'pub',
            label: ' ',
        }      
    ]

    useEffect(() => {
        fetch(`${BASE_NAME}/data/publicaciones.csv`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.text();
        })
        .then(data => {
            const parsedData = Papa.parse(data, { header: true,  delimiter: ';' }).data;
            setRowCount(parsedData.length);
            let pubsBib = []
            parsedData.forEach(row => {
                pubsBib.push({'pub': bibtexToIEEE(row['pub'])})
            })
            console.log(pubsBib)
            setPublicaciones(pubsBib);
            setLoading(false);
        })
        .catch(error => console.error('Error fetching CSV data:', error));
    }, [])


    return (
        <>
        {
            loading ? 
            <div className="flex flex-col h-screen justify-center items-center h-full">
                <Spinner className="h-12 w-12" />
            </div>
            :
            <section className="py-32">
                <div className="container mx-auto">
                    <div className="items-center justify-center flex">
                        <div className="w-full px-12 mb-12 px-4">
                            <CardTable 
                                title={t(`${translationPrefix}.papers`)}
                                icon={faGraduationCap}
                                columns={columns} 
                                rows={publicaciones}
                                rowCount={rowCount}
                            />
                        </div>
                    </div>
                </div>
            </section>
        }
        </>
    );
}

export default Papers;